var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.listItemCssClasses,on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.$emit('sort', _vm.header)}}},[_vm._v(_vm._s(_vm.header.title))])}
var staticRenderFns = []

export { render, staticRenderFns }